var React = require('react');

function IconBack (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.27334 8.16944L1.0674 8.16944L1.91954 9.02275L6.77287 13.8828L7.11759 13.5385L6.77287 13.8828C6.83793 13.9479 6.83793 14.0523 6.77287 14.1174C6.70819 14.1822 6.60515 14.1822 6.54046 14.1174L0.547132 8.11585C0.517599 8.08628 0.500002 8.04799 0.500002 7.99517C0.500002 7.9384 0.520273 7.9014 0.540466 7.88118L6.5281 1.88529C6.57059 1.84631 6.61375 1.83268 6.65333 1.83268C6.70546 1.83268 6.74116 1.84784 6.77287 1.87959C6.83793 1.94474 6.83793 2.04911 6.77287 2.11426L6.77263 2.11451L1.9193 6.9812L1.06857 7.83427L2.27334 7.83427L15.3333 7.83427C15.4232 7.83427 15.5 7.91017 15.5 8.00185C15.5 8.09353 15.4232 8.16944 15.3333 8.16944L2.27334 8.16944Z","fill":"#444444","stroke":"#222222"}));
}

IconBack.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = IconBack;

IconBack.default = IconBack;
